
import Vue from 'vue'
import Router from 'vue-router'

import Home from '../views/Home.vue'
import Service from '../views/Service.vue'
import Portfolio from '../views/Portfolio.vue'
import Team from '../views/Team.vue'
import Research from '../views/Research.vue'
import Contact from '../views/Contact.vue'
import MemberPortal from '../views/MemberPortal.vue'
import Disclaimer from '../views/Disclaimer.vue'

Vue.use(Router)

const siteUrl = 'https://www.norlandadvisory.com'

function upsertMetaTag(attributes) {
  const tag = document.querySelector(attributes.selector)

  if(tag) {
    Object.keys(attributes).forEach((key) => {
      if(key !== 'selector') {
        tag.setAttribute(key, attributes[key])
      }
    })
    return tag
  }

  const newTag = document.createElement(attributes.tagName || 'meta')
  Object.keys(attributes).forEach((key) => {
    if(key !== 'selector' && key !== 'tagName') {
      newTag.setAttribute(key, attributes[key])
    }
  })
  document.head.appendChild(newTag)

  return newTag
}

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if(savedPosition) {
      return savedPosition
    }

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: Home,
      meta: {
        title: 'Home | Norland Advisory',
        description: 'Norland Advisory property strategy, consultation, and portfolio insights for property management, buyer agent, finance advice, and investment planning.',
        keywords: 'property management, buyer agent, finance advice, investment, property investment, portfolio strategy, Norland Advisory, commercial property advisory'
      }
    },
    {
      path: '/service',
      component: Service,
      meta: {
        title: 'Service Journey | Norland Advisory',
        description: 'Explore our 7-stage investment service flow covering buyer agent support, finance advice, property management, and strategic investment guidance.',
        keywords: 'property management, buyer agent, finance advice, investment, property investment service, advisory service, portfolio guidance'
      }
    },
    {
      path: '/portfolio',
      component: Portfolio,
      meta: {
        title: 'Recent Acquisitions | Norland Advisory',
        description: 'Review recent property acquisitions, yield metrics, and growth performance across investment and property management opportunities.',
        keywords: 'investment property, property management, buyer agent, finance advice, portfolio growth, acquisition strategy, property advisory'
      }
    },
    {
      path: '/team',
      component: Team,
      meta: {
        title: 'Team Structure | Norland Advisory',
        description: 'Meet our founder, consultants, acquisition, settlement, and partner teams.'
      }
    },
    {
      path: '/research',
      component: Research,
      meta: {
        title: 'Research & Whitepapers | Norland Advisory',
        description: 'Browse market research reports and request download access through our form.'
      }
    },
    {
      path: '/contact',
      component: Contact,
      meta: {
        title: 'Contact Us | Norland Advisory',
        description: 'Get in touch with Norland Advisory for free or paid property consultations.'
      }
    },
    {
      path: '/portal',
      component: MemberPortal,
      meta: {
        title: 'Member Portal | Norland Advisory',
        description: 'Access your personalised property portfolio dashboard.'
      }
    },
    {
      path: '/disclaimer',
      component: Disclaimer,
      meta: {
        title: 'Full Disclaimer | Norland Advisory',
        description: 'Read the full disclaimer for all information presented on the Norland Advisory website.'
      }
    }
  ]
})

router.afterEach((to) => {
  const fallbackTitle = 'Norland Advisory'
  const fallbackDescription = 'Norland Advisory property investment consultation and strategy.'
  const fallbackKeywords = 'property management, buyer agent, finance advice, investment, property investment, commercial property advisory, portfolio strategy, Norland Advisory, property consultation, investment guidance'
  const title = to.meta && to.meta.title ? to.meta.title : fallbackTitle
  const description = to.meta && to.meta.description ? to.meta.description : fallbackDescription
  const keywords = to.meta && to.meta.keywords ? to.meta.keywords : fallbackKeywords

  document.title = title

  upsertMetaTag({
    selector: 'meta[name="description"]',
    tagName: 'meta',
    name: 'description',
    content: description
  })

  upsertMetaTag({
    selector: 'meta[name="keywords"]',
    tagName: 'meta',
    name: 'keywords',
    content: keywords
  })

  upsertMetaTag({
    selector: 'meta[name="robots"]',
    tagName: 'meta',
    name: 'robots',
    content: 'index, follow'
  })

  upsertMetaTag({
    selector: 'meta[property="og:title"]',
    tagName: 'meta',
    property: 'og:title',
    content: title
  })

  upsertMetaTag({
    selector: 'meta[property="og:description"]',
    tagName: 'meta',
    property: 'og:description',
    content: description
  })

  upsertMetaTag({
    selector: 'meta[property="og:type"]',
    tagName: 'meta',
    property: 'og:type',
    content: 'website'
  })

  upsertMetaTag({
    selector: 'meta[property="og:site_name"]',
    tagName: 'meta',
    property: 'og:site_name',
    content: 'Norland Advisory'
  })

  upsertMetaTag({
    selector: 'meta[property="og:url"]',
    tagName: 'meta',
    property: 'og:url',
    content: `${siteUrl}${to.fullPath || '/'}`
  })

  upsertMetaTag({
    selector: 'meta[name="twitter:card"]',
    tagName: 'meta',
    name: 'twitter:card',
    content: 'summary_large_image'
  })

  upsertMetaTag({
    selector: 'meta[name="twitter:title"]',
    tagName: 'meta',
    name: 'twitter:title',
    content: title
  })

  upsertMetaTag({
    selector: 'meta[name="twitter:description"]',
    tagName: 'meta',
    name: 'twitter:description',
    content: description
  })

  const canonicalTag = document.querySelector('link[rel="canonical"]') || document.createElement('link')
  canonicalTag.setAttribute('rel', 'canonical')
  canonicalTag.setAttribute('href', `${siteUrl}${to.fullPath || '/'}`)
  if(!document.querySelector('link[rel="canonical"]')) {
    document.head.appendChild(canonicalTag)
  }
})

export default router
